import { useUserContext } from '@/context/UserContext.tsx';
import type { BlotterOrderEntry } from '@/store/blotter/types/BlotterOrderEntry.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { selectActiveTabClientId } from '@/store/tabs/selectors.ts';

export const useAccount = (orderFromBlotter: BlotterOrderEntry | undefined) => {
  const userContextValue = useUserContext();
  const clientId = useAppSelector((state) => selectActiveTabClientId(state));

  const accountForActiveTab = userContextValue?.currentUser.clients.find((c) => c.companyId === clientId);

  if (orderFromBlotter?.clientId) {
    return `${userContextValue.getCompanyName(orderFromBlotter.clientId)} (${orderFromBlotter.clientId})`;
  }
  if (accountForActiveTab) {
    return `${accountForActiveTab.companyName} (${accountForActiveTab.companyId})`;
  }
  if (userContextValue?.defaultClient) {
    return `${userContextValue.defaultClient.companyName} (${userContextValue.defaultClient.companyId})`;
  }
  return null;
};
